import { render, staticRenderFns } from "./RecurringPaymentFrequencyEditor.vue?vue&type=template&id=14140952&scoped=true"
import script from "./RecurringPaymentFrequencyEditor.vue?vue&type=script&lang=js"
export * from "./RecurringPaymentFrequencyEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14140952",
  null
  
)

export default component.exports